import axios from 'axios';
import { API_BASE_URL } from '../utils/apiConfig';

class PdfLessonService {
  getAuthHeaders() {
    const token = localStorage.getItem('token');
    return {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    };
  }

  getJsonHeaders() {
    const token = localStorage.getItem('token');
    return {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    };
  }

  /**
   * Upload PDF and extract text
   */
  async uploadPdf(file, useVision = false) {
    try {
      const formData = new FormData();
      formData.append('pdf', file);
      formData.append('useVision', String(useVision));

      const response = await axios.post(
        `${API_BASE_URL}/pdf-lessons/upload`,
        formData,
        this.getAuthHeaders()
      );

      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to upload PDF');
    }
  }

  /**
   * Generate enhanced lesson from PDF text
   */
  async generateLesson(pdfText, title = null, customPrompt = null) {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/pdf-lessons/generate-lesson`,
        { pdfText, title, customPrompt },
        this.getJsonHeaders()
      );

      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to generate lesson');
    }
  }

  /**
   * Generate quiz from PDF text
   */
  async generateQuiz(pdfText, numQuestions = 5) {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/pdf-lessons/generate-quiz`,
        { pdfText, numQuestions },
        this.getJsonHeaders()
      );

      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to generate quiz');
    }
  }

  /**
   * Generate both lesson and quiz
   */
  async generateAll(pdfText, title = null, numQuestions = 5, customPrompt = null) {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/pdf-lessons/generate-all`,
        { pdfText, title, numQuestions, customPrompt },
        this.getJsonHeaders()
      );

      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to generate content');
    }
  }

  /**
   * Create lesson directly from PDF upload
   */
  async createLessonFromPdf(file, unitId, title = null, generateQuiz = false, numQuestions = 5, customPrompt = null) {
    try {
      if (!file) {
        throw new Error('PDF file is required');
      }
      if (!unitId) {
        throw new Error('Unit ID is required');
      }
      
      const formData = new FormData();
      formData.append('pdf', file);
      formData.append('unitId', String(unitId));
      if (title) formData.append('title', title);
      formData.append('generateQuiz', String(generateQuiz));
      formData.append('numQuestions', String(numQuestions || 5));
      if (customPrompt) formData.append('customPrompt', customPrompt);

      const response = await axios.post(
        `${API_BASE_URL}/pdf-lessons/create-lesson`,
        formData,
        this.getAuthHeaders()
      );

      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || 'Failed to create lesson from PDF');
    }
  }
}

export default new PdfLessonService();

